<script setup>
const $props = defineProps({
    reason: {
        type: String,
        required: true
    },
    statusCode: {
        type: Number,
        required: true
    },
    title: {
        type: String,
        required: true
    }
});
</script>

<template>
    <main class="error-panel market-hero col-grow column justify-center">
        <div class="container-md q-px-md q-py-xl">
            <section aria-labelledby="error-panel-title" class="error-panel-frame readout-frame q-mx-auto q-pa-xl text-center">
                <p class="font-mono text-caption text-uppercase text-hint q-mt-none q-mb-md" data-test="error-eyebrow">Error {{ $props.statusCode }} · {{ $props.reason }}</p>
                <h1 id="error-panel-title" class="text-h4 text-weight-bold q-mt-none q-mb-sm">{{ $props.title }}</h1>
                <p class="text-body1 text-hint q-mt-none q-mb-lg">
                    <slot/>
                </p>
                <div class="error-actions row wrap justify-center" data-test="error-actions">
                    <slot name="actions"/>
                </div>
            </section>
        </div>
    </main>
</template>

<style lang="scss" scoped>
.error-panel {
    // The field runs straight into the footer, which rules itself off, so the hero's own rule would double the line.
    border-bottom: 0;

    .error-panel-frame {
        max-width: 560px;

        // Short centred copy wraps into lines of even length rather than leaving a word or two on a line of its own.
        h1,
        p {
            text-wrap: balance;
        }
    }

    // Quasar's gutter classes offset a row by half a gutter, which shows when the row is centred.
    .error-actions {
        gap: 8px;
    }
}
</style>
